// extracted by mini-css-extract-plugin
module.exports = {"blinkActive":"blinkActive--2UKqs","blink":"blink--2gsl5"};